import { loader } from '@monaco-editor/react';

const configureMonacoFormulaEditor = () => {
  loader.init().then(monaco => {
    const keywords = ['set', 'if', 'else', 'return', 'isnull', 'round', 'sum', 'min', 'max', 'floor', 'pmt_service_goalseek'];

    monaco.languages.register({ id: 'formula' });

    monaco.languages.setMonarchTokensProvider('formula', {
      keywords,
      operators: ['>', '<', '?', ':', '==', '<=', '>=', '!=', '&', '|', '+', '-', '*', '/', '&', '|', '%'],
      symbols: /[=><!~?:&|+\-*/^%]+/,
      ignoreCase: true,
      tokenizer: {
        root: [
          [/[a-zA-Z][\w$]*/, { cases: { '@keywords': 'keyword', '@default': '' } }],
          [/@+[a-zA-Z][\w$]*/, 'variable'],
          [/".*?"/, 'string'],
          [
            /@symbols/,
            {
              cases: {
                '@operators': 'operator',
                '@default': ''
              }
            }
          ]
        ]
      }
    });

    monaco.languages.setLanguageConfiguration('formula', {
      brackets: [
        ['(', ')', 'delimiter.parenthesis'],
        ['[', ']', 'delimiter.square'],
        ['{', '}', 'delimiter.curly']
      ]
    });

    monaco.editor.defineTheme('formula-theme', {
      base: 'vs',
      rules: [
        { token: 'keyword', foreground: '#df5320', fontStyle: 'bold' },
        { token: 'string', foreground: '#407ee7' },
        { token: 'variable', foreground: '#7b9726' },
        { token: 'operator', foreground: '#f22c40' }
      ],
      colors: {}
    });

    monaco.languages.registerCompletionItemProvider('formula', {
      provideCompletionItems: (_model, _position) => {
        const suggestions = [
          ...keywords.map(k => ({
            label: k,
            kind: monaco.languages.CompletionItemKind.Keyword,
            insertText: k
          }))
        ];
        return { suggestions };
      }
    });
  });
};

export default configureMonacoFormulaEditor;
